export async function createBaloonApp(props) {
  const { createApp } = await import(/* webpackChunkName: "vue" */ 'vue');
  const { default: App } = await import('@/vue/map_balloon');

  return createApp(App, props);
}
